export class PageUrl
{
  
  static readonly DashboardPage="/dashboard";
  static readonly UserPage="/users";
  static readonly ApplicationPage="/application";
  static readonly RequestsPage="/requests";
  static readonly PendingRequestPage="/pendingRequests";
  static readonly ReadRequestPage="/readRequests";
  static readonly ArchiveRequestPage="/archiveRequests";
  static readonly DuplicateRequestPage="/duplicateRequest";
  static readonly OutofOfficePage="/outofoffice";
  static readonly SummaryReportPage="/summaryReport";
  static readonly SubtypesPage="/subtypes" ;
  static readonly CompaniesPage="/companies" ;
  static readonly CompanySubtypesPage="/companysubtypes";
  static readonly ReminderFrequencyPage="/reminderfrequency" ;
  static readonly ProfilePage="/profile";
  static readonly LogoutPage="/logout" ;
  static readonly AddApplicationPage="/addapplications" ;
  static readonly AddSubtypesPage="/addsubtypes" ;
  static readonly EditApplicationsPage="/editapplications" ;
  static readonly EditSubtypesPage="/editsubtypes" ;
  static readonly ViewApplicationPage="/viewApplications" ;
  static readonly ConfigurationPage="/configuration" ;
  static readonly AddConfigurationPage="/addconfiguration" ;
  //static readonly ViewFrequencyPage="/viewFrequency" ;
  static readonly EditFrequencyPage="/editFrequency" ;
  static readonly AddEditCompaniesPage="/addEditCompanies" ;
  //static readonly ViewCompaniesPage="/viewCompanies" ;
  static readonly AddEditSubtypesPage ="/addEditCompanySubtypes" ;
  static readonly RolesPage ="/roles" ;
  static readonly AddEditRolesPage ="/addEditRoles" ;
  static readonly AssignRolesPage ="/assignRoles" ;
  static readonly UserManagementPage ="/userManagement" ;
  static readonly AssignUserRolePage ="/assignUserRoleManagement" ;
  static readonly ArchivalDashboardPage ="/archivaldashboard" ;
  static readonly JobsLogsPage="/archiveLog"
  static readonly DivisionPage="/division"
  static readonly BranchPage="/branch"
  static readonly CategoryPage="/category"
  static readonly CurrencyPage="/currency"
  static readonly ExchangeRatePage="/exchangeRate"
  static readonly AddDivisionPage="/addDivision" ;
  static readonly AddBranchPage="/addBranch" ;
  static readonly AddCategoryPage="/addCategory" ;
  static readonly AddCurrencyPage="/addCurrency" ;
  static readonly AddExchangeRatePage="/addExchangeRate" ;
  static readonly LoginPage="/login" ;
  static readonly CompanyDivisionPage="/companydivision";
  static readonly AddCompanyDivisionPage="/addcompanydivision";
  static readonly CompanyBranchPage="/companybranch";
  static readonly AddCompanyBranchPage="/addcompanybranch";
  static readonly CompanyCategoryPage="/companycategory";
  static readonly AddCompanyCategoryPage="/addcompanycategory";
  static readonly CompanyExchangeRatePage="/companyexchangerate";
  static readonly AddCompanyExchangeRatePage="/addcompanyexchangerate";
}

 